export default "__VITE_ASSET__DkwKUg3t__"